const _ = "_button_yww13_25", n = "_arrow_yww13_58", t = "_action_yww13_81", o = "_spinner_yww13_81", c = "_flexible_yww13_91", s = "_md_yww13_101", w = "_secondary_yww13_109", r = "_primary_yww13_118", e = "_critical_yww13_127", i = "_unset_yww13_136", a = {
  button: _,
  arrow: n,
  action: t,
  spinner: o,
  flexible: c,
  md: s,
  secondary: w,
  primary: r,
  critical: e,
  unset: i
};
export {
  t as action,
  n as arrow,
  _ as button,
  e as critical,
  a as default,
  c as flexible,
  s as md,
  r as primary,
  w as secondary,
  o as spinner,
  i as unset
};
//# sourceMappingURL=button.module.less.js.map
